"use strict";

var _classCallCheck = require("/var/www/rememberme/admin/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Result serves as data structure for the AnalysisWorkerWrapper request result.
 */

var Result =
/**
 * Initializes a result.
 *
 * @param {Object} result The result.
 * @param {Object} [data] Optional extra data.
 */
function Result(result) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _classCallCheck(this, Result);

  this.result = result;
  this.data = data;
};

exports.default = Result;